import { startTransition, useEffect, useState } from 'react';
import cn from 'clsx';
import { useSearchStore } from '@pkgs/components/hooks/stores/search/useSearchStore';
import { type InputTextSizesProps } from '@ev-tech/ui-core-components/InputText';
import { PropertyMarketingType } from '@ev-tech/search-modules-api';

import { Select } from '../Select';
import { useAppContext } from '../../hooks/useAppContext';

import styles from './BuyRentTabFilter.module.css';

type BuyRentFilterProps = {
  hasLabelHidden?: boolean;
  size?: InputTextSizesProps;
  className?: string;
  isInModal?: boolean;
  'data-testid'?: string;
};
export const BuyRentFilter = ({ hasLabelHidden, size, className, isInModal, 'data-testid': dataTestId }: BuyRentFilterProps) => {
  const { t } = useAppContext();
  const marketingType = useSearchStore((state) => state.marketingType);
  const setMarketingType = useSearchStore((state) => state.setMarketingType);
  const setPrice = useSearchStore((state) => state.setPrice);
  const [selectedMarketingType, setSelectedMarketingType] = useState(marketingType);

  useEffect(() => {
    setSelectedMarketingType(marketingType);
  }, [marketingType]);

  const items = [
    {
      id: PropertyMarketingType.sale,
      label: t('search.common.marketingType.sale'),
    },
    {
      id: PropertyMarketingType.rent,
      label: t('search.common.marketingType.rent'),
    },
  ];

  const handleOnChange = (nextMarketingType: PropertyMarketingType) => {
    setSelectedMarketingType(nextMarketingType);
    startTransition(() => {
      setMarketingType(nextMarketingType);
      setPrice(undefined);
    });
  };

  return (
    <Select
      className={cn(styles.select, className)}
      items={items}
      onChange={(value) => handleOnChange(value as PropertyMarketingType)}
      label={t('search.searchbar.advFilter.marketingType.label')}
      accessibilityLabel={t('search.select.hiddenAccessibilityText', {
        label: t('search.searchbar.advFilter.marketingType.label'),
      })}
      placeholder={t('search.searchbar.advFilter.marketingType.label')}
      value={selectedMarketingType}
      name="propertyMarketingType"
      hasLabelHidden={hasLabelHidden}
      size={size}
      arrowVariant="small"
      isInModal={isInModal}
      data-testid={dataTestId ?? 'search-components_buy-rent-filter'}
      variant="outlinedV2"
      offset={3}
    />
  );
};
